import { Card, Dropdown, List, Tag, Typography } from 'antd';
import moment from 'moment';
import Task from '../../../models/Task';
import TaskMenu from '../../Molecules/DropDownMenu/DropDownMenu';
import { ReactComponent as More } from '../../../res/svg/more-card-gray.svg';
import { taskStateItems, truncateStringEllipsis } from '../../../utils/functions';
import './GeneralCardView.less';
import AvatarStateUser from '../../Molecules/AvatarStateUser/AvatarStateUser';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { setTaskFilters } from '../../../store/slice/taskSlice';
/**
 * @component GeneralCardView.tsx
 * @description GeneralCardView component to show data
 * @return { Component }
 */
interface GeneralCardViewProps {
  data: Task[];
  deleteTaskModal? : (taskId: number) => void;
  actionCloneTask? : (taskId: number) => void;
  actionExportTask? :  (taskId: number, titulo: string)  => void;
}
function GeneralCardView(props: GeneralCardViewProps) {
  const { Title, Text } = Typography;
  const dispatch = useAppDispatch();
  const filtros = useAppSelector(state => state.task.filtros);
  const totalItems = useAppSelector(state => state.task.totalItems);

  const deleteTask = (taskId: number) => {
    if(props.deleteTaskModal){
      props.deleteTaskModal(taskId);
    }
  }

  const cloneTask = (taskId: number) => {
    if(props.actionCloneTask){
      props.actionCloneTask(taskId);
    }
  }

  return (
    <List
      grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 4, xxl: 4 }}
      pagination={{
        defaultPageSize:filtros.pageSize,
        locale: { items_per_page: '/ página' },
        className: 'pagination-cards',
        current: Math.max(filtros.page, 1),
        total: totalItems,
        pageSize: filtros.pageSize,
        onChange: (page, pageSize) => {
          dispatch(setTaskFilters({ page, pageSize }));
        },
      }}
      dataSource={props.data}
      renderItem={(task, key) => (
        <Card key={key} className="org-general-card">
          <div className="org-general-card__header">
            <div className="org-general-card__header__row">
                <Title title={task.titulo} level={5}>{truncateStringEllipsis(task.titulo, 48)}</Title>
              <Text className="subtitle">
                {'Creada por'} <span className="subtitle__user">{task.usuario!.nombre}</span> {`${moment(task.createdAt).format('DD/MM/YYYY')}`}
              </Text>
            </div>
            <Dropdown overlay={
              <TaskMenu
                task={task}
                deleteTaskModal={deleteTask}
                actionExportTask={props.actionExportTask}
                actionCloneTask={cloneTask}/>
            } placement="bottomLeft">
              <More className="org_general_card__more"/>
            </Dropdown>
          </div>
          <div className="org_general_card__tag">
          <Tag style={{color: `#${task?.tipotarea?.color}`, borderColor: `#${task?.tipotarea?.color}`}}>{task?.tipotarea?.tipotarea}</Tag>
            <Tag className={taskStateItems(task.estado!).className}>
              {taskStateItems(task.estado!).title}
            </Tag>
          </div>
          <div className="org_general_card__description">
            <Text className="title">Descripción</Text>
            <Text className="subtitle" title={task.descripcion}>{truncateStringEllipsis(task.descripcion, 80)}</Text>
          </div>
          <div className="org_general_card__description">
            <Text className="title">Observaciones</Text>
            <Text className="subtitle" title={task.observaciones}>{truncateStringEllipsis(task.observaciones, 80)}</Text>
          </div>
          <div className="org_general_card__assign">
            <Text className="title">Asignado(s)</Text>
            {
              task.tareaUsuario![0] ?
              <div className={'assign-users-cards'}>
                <AvatarStateUser arrayUsers = {task.tareaUsuario}/>
              </div> : <div className={'none-users'}> - </div>
            }
          </div>

          <div className="org_general_card__date__container">
            <Text className="title">Realización:</Text>
            <Text className="subtitle">
              <>
                {
                  task.fechaDesde ?
                  <>
                    {moment(task.fechaDesde).format('DD/MM/YYYY')} - {moment(task.fechaHasta).format('DD/MM/YYYY')}
                  </> : <>-</>
                }
              </>
            </Text>
          </div>
        </Card>
      )}
    />
  );
}
export default GeneralCardView;
